module.exports = __webpack_public_path__ + "static/media/galdinsLose_500_1000.ae297b6c.png";